module.exports = __webpack_public_path__ + "static/media/products_specification_en.da440afa.md";